import MoveCanvas from './MoveCanvas';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'moveCanvas' ],
  moveCanvas: [ 'type', MoveCanvas ]
};